// extracted by mini-css-extract-plugin
module.exports = {"playerselect":"playerselect__38fad","playerselect__options":"playerselect__options__2ZEEl","radiobutton":"radiobutton__mwPnf","checked":"checked__TbYz-"};